/**
 * Local-midnight timestamp for `date`, the boundary day bucketing is measured
 * from. Bucketing on midnight rather than a rolling 24h window is what keeps a
 * "Yesterday" label stable across re-renders within the same day.
 */
export const startOfLocalDay = (date: Date): number => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
};

/** `Jun 2`, or `Jun 2, 2024` when the date falls outside the viewer's current year. */
export const formatNamedDate = (date: Date, now: Date): string => {
  const sameYear = date.getFullYear() === now.getFullYear();
  return date.toLocaleDateString(
    'en-US',
    sameYear ? { month: 'short', day: 'numeric' } : { month: 'short', day: 'numeric', year: 'numeric' }
  );
};
